import React from "react";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import StripePayment from "./StripePayment";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY)

const Stripe = () => {
  return (
    <Elements stripe={stripePromise}>
     <StripePayment/>
    </Elements>
  );
};

export default Stripe;







